import * as React from "react";
import { AppUtils } from "source/framework/appUtils";
import { ICodeTitle } from "source/models/common/codeTitle";
import { userParameterCodeShowDocumentPreview } from "source/models/common/webConsts";
import { ISavedReport } from "source/models/report/savedReport";
import { ITaskPage } from "source/models/task/taskPage";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IIdTitle, IdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType, ContentPagePanelType, FrontPagePanelSize, ReportSharingType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISavedChartPanel, SavedChartPanel } from "source/models/chart/savedChartPanel";
import { IListFilterItem, ListFilterItem } from "source/models/common/listFilterItem";
import { IPagePanel, PagePanel } from "source/models/common/pagePanel";
import { ISavedListFilter } from "source/models/common/savedListFilter";
import { ITypedOption } from "source/models/common/typedOption";
import { IReportItem, ReportItem } from "source/models/report/reportItem";
import { getStateChangeAfterChangeActiveReport, getStateChangeAfterChangeActiveSavedReport, handleRemoveSavedReport, ReportItems } from "source/models/report/reportItems";
import { recordLockManager } from "source/models/services/recordLockService";
import * as taskService from "source/models/services/taskService";
import * as userService from "source/models/services/userService";
import { IAppSessionState } from "source/models/store/storeTypes";
import { DashboardPanelList } from "source/components/app/DashboardPanelList";
import { HeaderMenuItem, NavigationMenu } from "source/components/app/NavigationMenu";
import { UserMenu } from "source/components/app/UserMenu";
import { ListFilterSaveDialog } from "source/components/framework/Filters/ListFilterSaveDialog";
import { PageContainer } from "source/components/framework/Page/PageContainer";
import { PageContent } from "source/components/framework/Page/PageContent";
import { PageDashboard } from "source/components/framework/Page/PageDashboard";
import { PageListAndReportsContainer } from "source/components/framework/Page/PageListAndReportsContainer";
import { PageReportsContainer } from "source/components/framework/Page/PageReportsContainer";
import { PageTabs } from "source/components/framework/Page/PageTabs";
import { PageTopBar } from "source/components/framework/Page/PageTopBar";
import { IPageNavMenuItem } from "source/components/framework/PageNav/PageNavMenuItems";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { ReportSettings } from "source/components/framework/ReportSettings";
import { PageNavMenuReportList } from "source/components/report/PageNavMenuItemReportList/PageNavMenuItemReportList";
import { ISaveReportFilters } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog";
import { SaveReportDialog } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog/SaveReportDialog";
import { TaskPageFilterDrawer } from "./TaskPageFilterDrawer";
import { TaskList } from "../TaskList";
import { TaskPageDashboardChart } from "./TaskPageDashboardChart";
import { TaskPageReport } from "./TaskPageReport";
import { TaskPageReportFilterPanel } from "./TaskPageReportFilterPanel";
import { TaskSettingsDialog, TaskSettingsDialogMenuItem } from "../TaskSettingsDialog/TaskSettingsDialog";
import { TaskTrashBinDialog } from "../TaskTrashBinDialog";
import { AddButton } from "source/components/framework/Button/AddButton";
import { abortManager } from "source/models/services/tokenService";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { TDefaultListFilter } from "source/models/common/defaultListFilter";
import { RouteComponentProps } from "react-router-dom";
import { ITaskListState, ITaskReportState, setTaskListDefaultFilter, setTaskReportDefaultFilter } from "source/models/store/task";
import { TDefaultReportFilter } from "source/models/common/defaultReportFilter";
import { IChartItem } from "source/models/chart/chartItem";
import { removeFrontPanelFromState } from "source/models/store/front";
import { getTaskGeneralFilterFromFilterState, getFilterStateFromTaskGeneralFilter, ITaskPageFilterState, TaskStateIdFilterActive, TaskStateIdFilterArchived, getTaskStates, taskStateDividerId } from "./TaskPageUtils";
import { TaskPageSelectChartDrawer } from "./TaskPageSelectChartDrawer";
import { ISharedPanel } from "source/models/panel/sharedPanel";

/* eslint-disable no-unused-vars */
export const enum TaskPageViewType {
    Tasks = "0",
    Reports = "1",
    Dashboard = "2",
}
/* eslint-enable no-unused-vars */

// TaskPage
export interface ITaskPageOwnProps {
}

export interface ITaskPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    taskPage: ITaskPage;
    list: ITaskListState;
    report: ITaskReportState;
}

export interface ITaskPageDispatchProps {
    onGetTaskPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
    onRefreshSessionState: () => void;
}

export interface ITaskPagePathProps {
    page: string;
}

type TaskPageProp = ITaskPageOwnProps & ITaskPageStateProps & ITaskPageDispatchProps & RouteComponentProps<ITaskPagePathProps>;

interface ITaskPageState extends ITaskPageFilterState {
    initialized: boolean;
    listDataPreloaded: boolean;
    listAddRecord: boolean;
    units: IIdTitleNode[];
    states: IIdColorTitle[];
    priorities: IIdTitle[];
    taskTypes: ITaskEditTypeItem[];
    taskTypesForReportsAndCharts: ITaskEditTypeItem[];
    handlers: IIdTitle[];
    personsInCharge: IIdTitle[];
    activeViewTypeId: TaskPageViewType;
    activeCompanyId: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    settingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showListFilter: boolean;
    listFilterFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Permissions
    dataId: number;
    canCreateTasks: boolean;
    // Channel Settings
    showSettingsDialog: boolean;
    // Reports
    loadingReports: boolean;
    reports: IReportItem[];
    savedReports: IReportItem[];
    reportChartItems: IChartItem[]; //Not in use
    activeReportId: string;
    activeSavedReportId: string;
    reportFilterReport: IReportItem;
    showReportSaveDialog: boolean;
    reportSaveDialogReport: IReportItem;
    reportSaveDialogGeneralFilter: any;
    reportSaveDialogReservedNames: string[];
    reportSaveDialogOnGetReportSaveFilters: () => ISaveReportFilters;
    // Dashboard
    showDashBoardNavPanel: boolean;
    dashBoardPanels: IPagePanel[];
    showDashBoardChartPanelSelect: boolean;
    showDashBoardChartPanel: boolean;
    dashBoardChartPanelFilter: ITaskPageFilterState;
    dashBoardChartPanelVisible: boolean;
    dashBoardChartPanelPanelSize: number;
    dashBoardChartPanelChartPanel: ISavedChartPanel;
    dashBoardChartPanelReservedChartPanelNames: string[];
    // TrashBin
    showTrashBinDialog: boolean;
    // Preview
    showDocumentPreview: boolean;
}

export class TaskPage extends React.Component<TaskPageProp, ITaskPageState> {
    _isMounted: boolean;

    getUnits = (units: IIdTitleNode[]): IIdTitleNode[] => {
        const result: IIdTitleNode[] = [];
        result.push(IdTitleNode.createIdTitleNode(Base.emptyGuid, "'" + Translations.All + "'", []));
        return result.concat(units);
    };
    
    getIdTitles = (idTitles: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(idTitles);
    };
    
    getTaskTypes = (taskTypes: ITaskEditTypeItem[]): ITaskEditTypeItem[] => {
        const result: ITaskEditTypeItem[] = [];
        const allItem = new TaskEditTypeItem();
        allItem.id = Base.emptyGuid;
        allItem.code = "'" + Translations.All + "'";
        result.push(allItem);
        return result.concat(taskTypes);
    };

    getHandlers = (handlers: ICodeTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle("", "'" + Translations.All + "'"));
        return result.concat(handlers.map(i => IdTitle.createIdTitle(i.code, i.title)));
    };
    
    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.Tasks, Translations.Tasks,
            {
                unitIds: [],
                stateIds: [TaskStateIdFilterActive],
                priorityIds: [],
                taskTypeIds: [],
                handlerUserCodes: [],
                personInChargeUserCodes: [],
                taskTypeHeaderFields: null,
                taskTypeFields: null
            }, "modifyDate", false, 0));
        result.push(ListFilterItem.createListFilterItem(Translations.Archived, Translations.Archived,
            {
                unitIds: [],
                stateIds: [TaskStateIdFilterArchived],
                priorityIds: [],
                taskTypeIds: [],
                handlerUserCodes: [],
                personInChargeUserCodes: [],
                taskTypeHeaderFields: null,
                taskTypeFields: null
            }, "modifyDate", false, 1));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: ITaskPageState): boolean => {
        return TaskPageFilterDrawer.filterIsSet(state, state);
    };

    getSettingsActions = (): IPageNavMenuItem[] => {
        const props = this.props;
        const sessionState = props.appState.state;
        const result: IPageNavMenuItem[] = [];
        if (props.taskPage?.canEditAllModuleProperties) {
            result.push({ id: TaskSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: TaskSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
        }
        if (props.taskPage?.canEditLimitedModuleProperties) {
            result.push({ id: Translations.CompanyTaskTypeSettings, title: Translations.CompanyTaskTypeSettings, divider: true });
            result.push({ id: TaskSettingsDialogMenuItem.CompanyTaskTypes, title: Translations.TaskTypes });
            result.push({ id: TaskSettingsDialogMenuItem.TaskStates, title: Translations.TaskDefaultStates });
            result.push({ id: TaskSettingsDialogMenuItem.TaskPriorities, title: Translations.TaskDefaultPriorities });
        }
        if (sessionState?.isSuperAdmin) {
            result.push({ id: Translations.SystemSettings, title: Translations.SystemSettings, divider: true });
            result.push({ id: TaskSettingsDialogMenuItem.DefaultTaskTypes, title: Translations.DefaultTaskTypes });
            result.push({ id: TaskSettingsDialogMenuItem.DefaultTaskStates, title: Translations.TaskDefaultStates });
            result.push({ id: TaskSettingsDialogMenuItem.DefaultTaskPriorities, title: Translations.TaskDefaultPriorities });
        }
        return result;
    };

    getDefaultTaskPageViewType = (props: TaskPageProp): TaskPageViewType => {
        if (!props.match.params.page) return TaskPageViewType.Dashboard;
        if (props.match.params.page.equalIgnoreCase("list")) return TaskPageViewType.Tasks;
        if (props.match.params.page.equalIgnoreCase("reports")) return TaskPageViewType.Reports;
        return TaskPageViewType.Dashboard;
    };

    getDashBoardPanels(newTaskTypes: ITaskEditTypeItem[], aChartPanels: ISavedChartPanel[]): IPagePanel[] {
        const props = this.props;
        const result = props.taskPage?.panels ?? [];
        const chartPanels = aChartPanels ?? [];
        const taskTypes = newTaskTypes ?? [];
        const newChartPanels: ISavedChartPanel[] = [];
        for (const chartPanel of chartPanels) {
            const chart = taskTypes.find(i => i.id === chartPanel.reportId)?.charts.find(c => c.name === chartPanel.chartId);
            if (chartPanel.id === chartPanel.reportId) {
                chartPanel.reportTitle = chart
                    ? chart.title
                    : chartPanel.id;
            } else {
                chartPanel.reportTitle = chartPanel.id;
            }
            chartPanel.disabled = !chart;
            newChartPanels.push(chartPanel);
        }
        return PagePanel.sortPagePanels(result.concat(newChartPanels));
    };

    constructor(props: TaskPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, getFilterStateFromTaskGeneralFilter);
        const reports = this.getHtlmlReportItems();
        const activeSavedReportId = props.report.defaultFilter?.savedReportId
            ? props.report.defaultFilter.savedReportId
            : "";
        const activeReportId = !activeSavedReportId && props.report.defaultFilter?.reportId
            ? props.report.defaultFilter.reportId
            : (reports.length > 0
                ? reports[0].id
                : "");
        const state = {
            ...filterProps,
            initialized: !!props.taskPage,
            activeViewTypeId: this.getDefaultTaskPageViewType(props),
            activeCompanyId: sessionState.companyId,
            listDataPreloaded: true,
            listAddRecord: false,
            units: this.getUnits(props.taskPage?.units ?? []),
            states: getTaskStates(props.taskPage?.states ?? []),
            priorities: this.getIdTitles(props.taskPage?.priorities ?? []),
            taskTypes: this.getTaskTypes(props.taskPage?.taskTypes ?? []),
            taskTypesForReportsAndCharts: props.taskPage?.taskTypes ?? [],
            handlers: this.getHandlers(props.taskPage?.handlers ?? []),
            personsInCharge: this.getHandlers(props.taskPage?.personsInCharge ?? []),
            settingsActions: this.getSettingsActions(),
            // Filters
            listFilterIsSet: false,
            activeFilterId: filters[0].id,
            activeSavedFilterId: "",
            filters,
            savedFilters: ListFilterItem.getListFilterItems(props.taskPage?.companyFilters, props.taskPage?.userFilters),
            showListFilter: false,
            listFilterFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Permissions
            dataId: props.dataId,
            canCreateTasks: props.taskPage?.canCreateTasks ?? false,
            // Settings
            showSettingsDialog: false,
            // Reports
            loadingReports: true,
            reports,
            savedReports: [],
            reportChartItems: [], //Not in use
            activeReportId,
            activeSavedReportId,
            reportFilterReport: null,
            showReportSaveDialog: false,
            reportSaveDialogReport: null,
            reportSaveDialogGeneralFilter: null,
            reportSaveDialogReservedNames: [],
            reportSaveDialogOnGetReportSaveFilters: null,
            // Dashboard
            showDashBoardNavPanel: false,
            dashBoardPanels: [],
            showDashBoardChartPanelSelect: false,
            showDashBoardChartPanel: false,
            dashBoardChartPanelFilter: null,
            dashBoardChartPanelVisible: false,
            dashBoardChartPanelPanelSize: FrontPagePanelSize.OneXOne,
            dashBoardChartPanelChartPanel: null,
            dashBoardChartPanelReservedChartPanelNames: [],
            // TrashBin
            showTrashBinDialog: false,
            // Preview
            showDocumentPreview: false,
        };
        this.state = {
            ...state,
            dashBoardPanels: this.getDashBoardPanels(props.taskPage?.taskTypes, props.taskPage?.chartPanels),
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setTaskListDefaultFilter(null);
    }

    setGeneralFilterToDefaultReports = (state: { reports: IReportItem[] }, states: IIdColorTitle[], taskTypes: ITaskEditTypeItem[]) => {
        const taskType = taskTypes.length > 0 ? taskTypes.find(i => i.id !== Base.emptyGuid && i.id !== taskStateDividerId) : null;
        const taskTypeIds = taskType ? [taskType.id] : null;
        const taskState = states.length > 0 ? states.find(i => i.id !== Base.emptyGuid) : null;
        const stateIds = taskState ? [taskState.id] : null;
        for (const report of state.reports) {
            if (report.id !== Base.emptyGuid && report.id !== "00000000-0000-0000-0000-000000000001") continue;
            report.generalFilter = { taskTypeIds, stateIds };
        }
    };

    getReports = async (companyId: string) => {
        const newState = await ReportItems.getReportsState(companyId, this.state.activeReportId, this.state.activeSavedReportId, this.getHtlmlReportItems(), taskService.getTaskPageReportItems,
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: true });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: false });
            });
        if (!this._isMounted || !newState) return;
        this.setGeneralFilterToDefaultReports(newState, this.state.states, this.state.taskTypes);
        //const props = this.props;
        this.setState({
            ...newState,
            //SavedChartPanel.getDashBoardPanels(props.taskPage?.panels, props.taskPage?.chartPanels, newState.reportChartItems, ApplicationPermissionType.Task)
        }, () => {
            if (newState.activeReportId) {
                this.handleChangeActiveReport(newState.activeReportId, this.props.report.defaultFilter?.generalFilter, this.props.report.defaultFilter?.reportFilter);
            } else {
                this.handleChangeActiveSavedReport(newState.activeSavedReportId, this.props.report.defaultFilter?.generalFilter, this.props.report.defaultFilter?.reportFilter);
            }
            setTaskReportDefaultFilter(null);
        });
    };

    componentDidMount(): void {
        const sessionState = this.props.appState.state;
        recordLockManager.unlockAll(sessionState?.companyId, sessionState?.code);
        this.props.onGetTaskPage();
        this.getReports(sessionState.companyId);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: TaskPageProp, prevState: ITaskPageState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const equalCompanyIds = Base.equalStrArrays(prevProps.taskPage?.companies.map(i => i.id) ?? [], props.taskPage?.companies.map(i => i.id) ?? []);
        const prevCompanyId = prevProps.taskPage && prevProps.taskPage.companies.length > 0 ? prevProps.taskPage.companies[0].id : Base.emptyGuid;
        const companyId = props.taskPage && props.taskPage.companies.length > 0 ? props.taskPage.companies[0].id : Base.emptyGuid;
        const prevCanCreateTasks = prevProps.taskPage?.canCreateTasks ?? false;
        const canCreateTasks = props.taskPage?.canCreateTasks ?? false;
        const prevCanEditAllModuleProperties = prevProps.taskPage?.canEditAllModuleProperties ?? false;
        const canEditAllModuleProperties = props.taskPage?.canEditAllModuleProperties ?? false;
        const unitsData = props.taskPage?.units ?? [];
        const equalUnits = IdTitleNode.equalIds(prevProps.taskPage?.units ?? [], unitsData);
        const units = this.getUnits(unitsData);
        const statesData = props.taskPage?.states ?? [];
        const equalStates = IdTitle.equal(prevProps.taskPage?.states ?? [], statesData);
        const states = getTaskStates(statesData);
        const prioritiesData = props.taskPage?.priorities ?? [];
        const equalPriorities = IdTitle.equal(prevProps.taskPage?.priorities ?? [], prioritiesData);
        const priorities = this.getIdTitles(prioritiesData);
        const taskTypesData = props.taskPage?.taskTypes ?? [];
        const equalTaskTypes = IdTitle.equal(prevProps.taskPage?.taskTypes ?? [], taskTypesData);
        const taskTypes = this.getTaskTypes(taskTypesData);
        const handlersData = props.taskPage?.handlers ?? [];
        const equalHandlers = IdTitle.equal(prevProps.taskPage?.handlers ?? [], handlersData);
        const handlers = this.getHandlers(handlersData);
        const personsInChargeData = props.taskPage?.personsInCharge ?? [];
        const equalPersonsInCharge = IdTitle.equal(prevProps.taskPage?.personsInCharge ?? [], personsInChargeData);
        const personsInCharge = this.getHandlers(personsInChargeData);
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditAllModuleProperties === canEditAllModuleProperties &&
            prevCanCreateTasks === canCreateTasks && equalCompanyIds && equalUnits && equalStates && equalPriorities && equalTaskTypes && equalHandlers && equalPersonsInCharge) return;
        const savedFilters = ListFilterItem.getListFilterItems(props.taskPage?.companyFilters, props.taskPage?.userFilters);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const selectedStateIds = equalStates ? state.selectedStateIds : [Base.emptyGuid];
        const selectedPriorityIds = equalPriorities ? state.selectedPriorityIds : [Base.emptyGuid];
        const selectedTaskTypeIds = equalTaskTypes ? state.selectedTaskTypeIds : [Base.emptyGuid];
        const selectedHandlerUserCodes = equalHandlers ? state.selectedHandlerUserCodes : [""];
        const selectedPersonInChargeUserCodes = equalPersonsInCharge ? state.selectedPersonInChargeUserCodes : [""];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            canCreateTasks,
            initialized: !!props.taskPage,
            dashBoardPanels: this.getDashBoardPanels(taskTypes, props.taskPage?.chartPanels),
            activeViewTypeId: companyId !== sessionState.companyId ? TaskPageViewType.Tasks : state.activeViewTypeId,
            activeCompanyId: companyId,
            units,
            states,
            priorities,
            taskTypes,
            taskTypesForReportsAndCharts: taskTypesData,
            handlers,
            personsInCharge,
            selectedUnitIds,
            selectedStateIds,
            selectedPriorityIds,
            selectedTaskTypeIds,
            selectedHandlerUserCodes,
            selectedPersonInChargeUserCodes,
            savedFilters,
            activeSavedFilterId,
            settingsActions: this.getSettingsActions(),
            showDocumentPreview: props.taskPage?.showDocumentPreview ?? state.showDocumentPreview
        };
        const newState = { ...state, ...stateChange };
        this.setGeneralFilterToDefaultReports(newState, states, taskTypes);
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }
    
    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null) => {
        const state = this.state;
        let result = {
            selectedUnitIds: state.selectedUnitIds,
            selectedStateIds: state.selectedStateIds,
            selectedPriorityIds: state.selectedPriorityIds,
            selectedTaskTypeIds: state.selectedTaskTypeIds,
            selectedHandlerUserCodes: state.selectedHandlerUserCodes,
            selectedPersonInChargeUserCodes: state.selectedPersonInChargeUserCodes,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, getFilterStateFromTaskGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return {};
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return {};
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Task);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showListFilter: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            listFilterFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, getTaskGeneralFilterFromFilterState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Task);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: getTaskGeneralFilterFromFilterState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleShowListFilter = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showListFilter: this.state.activeViewTypeId !== TaskPageViewType.Reports,
            listFilterFilter: filter
        });
    };

    handleListFilterPanelOk = (closeDialog: boolean, newFilterState: ITaskPageFilterState): any => {
        const newState = {
            ...this.state,
            ...newFilterState
        };
        this.setState({
            showListFilter: !closeDialog,
            ...newFilterState,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return getTaskGeneralFilterFromFilterState(newState);
    };
    
    handleFilterPanelCancel = () => {
        this.setState({ showListFilter: false });
    };
    // #endregion Record Filter

    // #region Report
    getStateChangeAfterChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        return getStateChangeAfterChangeActiveReport(
            this.state,
            getFilterStateFromTaskGeneralFilter,
            this.getListFilterIsSet,
            activeReportId,
            additionalGeneralFilter,
            additionalReportFilter
        );
    };

    handleChangeActiveReport = (activeReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        this.setState(this.getStateChangeAfterChangeActiveReport(activeReportId, additionalGeneralFilter, additionalReportFilter));
    };

    getStateChangeAfterChangeActiveSavedReport = (activeSavedReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null): any => {
        return getStateChangeAfterChangeActiveSavedReport(
            this.state,
            getFilterStateFromTaskGeneralFilter,
            this.getListFilterIsSet,
            activeSavedReportId,
            additionalGeneralFilter,
            additionalReportFilter);
    };

    handleChangeActiveSavedReport = (activeSavedReportId: string, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedReport(activeSavedReportId, additionalGeneralFilter, additionalReportFilter));
    };

    handleRemoveSavedReport = async (reportId: string) => {
        this.setState(await handleRemoveSavedReport(
            this.state,
            getFilterStateFromTaskGeneralFilter,
            this.getListFilterIsSet,
            ApplicationPermissionType.Task,
            SaveReportDialog.removeReportFromDb,
            reportId
        ));
    };
    // #endregion Report

    setActiveViewType = (itemId: TaskPageViewType, listAddRecord: boolean, activeFilterOrReportId: string = null, activeSavedFilterOrReportId: string = null, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        const state = this.state;
        //To reset filter when filter/report is activated
        let newState = {};
        if (itemId === TaskPageViewType.Reports) {
            if (activeFilterOrReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(activeFilterOrReportId, additionalGeneralFilter, additionalReportFilter);
            } else if (activeSavedFilterOrReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(activeSavedFilterOrReportId, additionalGeneralFilter, additionalReportFilter);
            } else if (state.activeReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(state.activeReportId);
            } else if (state.activeSavedReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(state.activeSavedReportId);
            }
        } else if (itemId === TaskPageViewType.Tasks) {
            if (activeFilterOrReportId) {
                newState = this.getStateChangeAfterChangeActiveFilter(activeFilterOrReportId, additionalGeneralFilter);
            } else if (state.activeFilterId) {
                newState = this.getStateChangeAfterChangeActiveFilter(state.activeFilterId);
            } else if (state.activeSavedFilterId) {
                newState = this.getStateChangeAfterChangeActiveSavedFilter(state.activeSavedFilterId);
            }
        }
        this.setState({
            ...newState,
            activeViewTypeId: itemId,
            listDataPreloaded: false,
            listAddRecord
        });
    };

    handleSetActiveViewType = (itemId: TaskPageViewType, activeFilterOrReportId: string = null, activeSavedFilterOrReportId: string = null, additionalGeneralFilter: any = null, additionalReportFilter: any = null) => {
        this.setActiveViewType(itemId, false, activeFilterOrReportId, activeSavedFilterOrReportId, additionalGeneralFilter, additionalReportFilter);
    };

    handleAddTask = () => {
        this.setActiveViewType(TaskPageViewType.Tasks, true);
    };

    // #region Units
    handleRefreshPageData = async (companyId: string) => {
        const pageData = await taskService.getTaskPageData(companyId);
        const state = this.state;
        //Units
        const units = this.getUnits(pageData.units);
        const selectedUnitIds = IdTitleNode.keepAvailableSelectedIds(units, state.selectedUnitIds);
        //States
        const states = getTaskStates(pageData.states);
        const selectedStateIds = Base.keepAvailableSelectedIds(states, state.selectedStateIds);
        //Priorities
        const priorities = this.getIdTitles(pageData.priorities);
        const selectedPriorityIds = Base.keepAvailableSelectedIds(priorities, state.selectedPriorityIds);
        //TaskTypes
        const taskTypes = this.getTaskTypes(pageData.taskTypes);
        const selectedTaskTypeIds = Base.keepAvailableSelectedIds(taskTypes, state.selectedTaskTypeIds);
        let selectedTaskTypeFields = state.selectedTaskTypeFields;
        let selectedTaskTypeHeaderFields = state.selectedTaskTypeHeaderFields;
        if (state.selectedTaskTypeIds.length === 1 && selectedTaskTypeIds.length < 1 &&
            (state.selectedTaskTypeFields || state.selectedTaskTypeHeaderFields)) {
            selectedTaskTypeFields = "";
            selectedTaskTypeHeaderFields = "";
        }
        //Handlers and Handler filter user codes
        const handlers = this.getHandlers(pageData.handlers);
        const selectedHandlerUserCodes = Base.keepAvailableSelectedIds(handlers, state.selectedHandlerUserCodes, "");
        const personsInCharge = this.getHandlers(pageData.personsInCharge);
        const selectedPersonInChargeUserCodes = Base.keepAvailableSelectedIds(personsInCharge, state.selectedPersonInChargeUserCodes, "");
        const stateChange = {
            activeCompanyId: companyId,
            units,
            states,
            priorities,
            taskTypes,
            taskTypesForReportsAndCharts: pageData.taskTypes,
            handlers,
            personsInCharge,
            selectedUnitIds,
            selectedStateIds,
            selectedPriorityIds,
            selectedTaskTypeIds,
            selectedHandlerUserCodes,
            selectedPersonInChargeUserCodes,
            selectedTaskTypeFields,
            selectedTaskTypeHeaderFields,
            dashBoardPanels: this.getDashBoardPanels(pageData.taskTypes, pageData.chartPanels),
        };
        const newState = { ...state, ...stateChange };
        this.setGeneralFilterToDefaultReports(newState, states, taskTypes);
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };
    // #endregion Units

    handleShowDetailsPanel = (showDocumentPreview) => {
        this.setState({ showDocumentPreview });
        AppUtils.callService(() => userService.saveUserParameter(userParameterCodeShowDocumentPreview, showDocumentPreview ? "TRUE" : "FALSE"), false, true);
    };
        
    // #region Settings
    handleOpenSettingsDialog = () => {
        this.setState({
            showSettingsDialog: true
        });
    };
    
    handleSettingsDialogOk = async () => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        await this.handleRefreshPageData(this.state.activeCompanyId);
    };
    // #endregion Settings

    // #region Report Filter
    // handleOpenReportFilterDialog = () => {
    //     const report = ReportItem.getActiveReport(this.state);
    //     if (!report) return;
    //     this.setState({
    //         reportFilterReport: report
    //     });
    // };

    onTaskReportFilterPanelOk = (filterState: ITaskPageFilterState, parameters: ITaskDataRow, showInFrontPage: boolean): ISaveReportFilters => {
        const state = this.state;
        const stateUdpate = SaveReportDialog.getReportStateChangeAfterReportFilterChange(state, parameters, showInFrontPage);
        if (!stateUdpate) return;
        const stateChange = {
            selectedUnitIds: filterState.selectedUnitIds,
            selectedStateIds: filterState.selectedStateIds,
            selectedPriorityIds: filterState.selectedPriorityIds,
            selectedTaskTypeIds: filterState.selectedTaskTypeIds,
            selectedHandlerUserCodes: filterState.selectedHandlerUserCodes,
            selectedPersonInChargeUserCodes: filterState.selectedPersonInChargeUserCodes,
            selectedTaskTypeHeaderFields: filterState.selectedTaskTypeHeaderFields,
            selectedTaskTypeFields: filterState.selectedTaskTypeFields,
            reports: stateUdpate.reports,
            savedReports: stateUdpate.savedReports
        };
        const newState = {
            ...this.state,
            ...stateChange
        };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return {
            generalFilter: getTaskGeneralFilterFromFilterState(newState),
            reportFilter: stateUdpate.reportFilter,
            showInFrontPage
        };
    };
    // #endregion Report Filter

    // // #region Report Save
    // handleSetSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
    //     const state = this.state;
    //     if (state.activeReportId) {
    //         const reports = state.reports.slice(0);
    //         const index = reports.findIndex(i => i.id === state.activeReportId);
    //         if (index < 0) return;
    //         const report = new ReportItem(reports[index]);
    //         report.sortColumn = sortColumn;
    //         report.sortOrderIsAsc = sortOrderIsAsc;
    //         reports[index] = report;
    //         const newState = { ...this.state, reports };
    //         this.setState({
    //             reports,
    //             listFilterIsSet: this.getListFilterIsSet(newState)
    //         });
    //     } else if (state.activeSavedReportId) {
    //         const savedReports = state.savedReports.slice(0);
    //         const index = savedReports.findIndex(i => i.id === state.activeSavedReportId);
    //         if (index < 0) return;
    //         const savedReport = new ReportItem(savedReports[index]);
    //         savedReport.sortColumn = sortColumn;
    //         savedReport.sortOrderIsAsc = sortOrderIsAsc;
    //         savedReports[index] = savedReport;
    //         const newState = { ...this.state, savedReports };
    //         this.setState({
    //             savedReports,
    //             listFilterIsSet: this.getListFilterIsSet(newState)
    //         });
    //     }
    // };

    handleSaveAsReportsModifiedReport = async (saveAs: boolean, onGetReportSaveFilters: () => ISaveReportFilters) => {
        const state = this.state;
        const report = ReportItem.getActiveReport(state);
        if (!report) return;
        if (!saveAs) {
            const savedReport = await SaveReportDialog.saveReportToDb(report, getTaskGeneralFilterFromFilterState(state), state.activeCompanyId, ApplicationPermissionType.Task);
            this.setState(SaveReportDialog.getReportStateChangeAfterReportSave(this.state, report.id, savedReport, report.reportSharingType));
        } else {
            this.setState({
                showReportSaveDialog: true,
                reportSaveDialogReport: report,
                reportSaveDialogReservedNames: state.savedReports.map(i => i.id).concat(state.reports.map(i => i.title)),
                reportSaveDialogGeneralFilter: getTaskGeneralFilterFromFilterState(state),
                reportSaveDialogOnGetReportSaveFilters: onGetReportSaveFilters
            });
        }
    };

    handleReportSaveDialogOk = (savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        this.setState(SaveReportDialog.getReportStateChangeAfterReportSave(this.state, "", savedReport, reportSharingType));
    };

    handleReportSaveDialogCancel = () => {
        this.setState({
            showReportSaveDialog: false
        });
    };
    // // #endregion Report Save

    // #region Dashboard
    handleToggleShowDashboardNavPanel = () => {
        this.setState({ showDashBoardNavPanel: !this.state.showDashBoardNavPanel });
    };

    handleUpdateDashBoardPanels = async (panels: IPagePanel[]) => {
        this.setState({
            dashBoardPanels: panels
        });
    };

    getSavedChartPanels = (panels: IPagePanel[]): ISavedChartPanel[] => {
        return panels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
    };
        
    handleSaveDashBoardPanels = async (panels: IPagePanel[]) => {
        const pagePanels = panels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        await taskService.saveTaskPanels(pagePanels);
        const chartPanels = this.getSavedChartPanels(panels);
        await taskService.saveTaskChartPanels(chartPanels);
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleDashboardSavedFilterClick = (filterId: string) => {
        this.handleChangeActiveSavedFilter(filterId);
        this.setState({
            activeViewTypeId: TaskPageViewType.Tasks,
            listDataPreloaded: false
        });
    };

    handleDashboardFilterClick = (filterId: string) => {
        this.handleChangeActiveFilter(filterId);
        this.setState({
            activeViewTypeId: TaskPageViewType.Tasks,
            listDataPreloaded: false
        });
    };

    handleDashboardSavedReportClick = (reportId: string) => {
        this.handleChangeActiveSavedReport(reportId);
        this.setState({
            activeViewTypeId: TaskPageViewType.Reports,
            listDataPreloaded: false
        });
    };

    handleDashboardReportClick = (reportId: string) => {
        this.handleChangeActiveReport(reportId);
        this.setState({
            activeViewTypeId: TaskPageViewType.Reports,
            listDataPreloaded: false
        });
    };

    handleShowChartPanelProperties = (panelId: string) => {
        if (!panelId) return;
        const state = this.state;
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const chartPanel = chartPanels.find(i => i.id === panelId);
        if (!chartPanel) return;
        this.setState({
            showDashBoardChartPanel: true,
            reportFilterReport: null,
            dashBoardChartPanelFilter: getFilterStateFromTaskGeneralFilter(chartPanel.generalFilter),
            dashBoardChartPanelVisible: chartPanel.visible,
            dashBoardChartPanelPanelSize: chartPanel.size,
            dashBoardChartPanelChartPanel: chartPanel,
            dashBoardChartPanelReservedChartPanelNames: chartPanels.filter(i => i.id !== panelId).map(i => i.reportTitle)
        });
    };
    
    handleAddChartPanel = (sharedPanel: ISharedPanel | null) => {
        //Select chart
        if (!sharedPanel) {
            this.setState({
                showDashBoardChartPanelSelect: true,
            });
            return;
        }
        //Use Shared Panel
        const state = this.state;
        const taskType = state.taskTypes.find(i => i.id === sharedPanel.reportId);
        if (!taskType) return;
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const position = Base.maxVal(state.dashBoardPanels.map(i => i.position), -1) + 1;
        const chartPanel = SavedChartPanel.CreateSavedChartPanelBySharedPanel(sharedPanel, position, ApplicationPermissionType.Task);
        chartPanel.id = "";
        chartPanel.visible = true;
        this.setState({
            showDashBoardChartPanel: true,
            reportFilterReport: null,
            dashBoardChartPanelFilter: getFilterStateFromTaskGeneralFilter(chartPanel.generalFilter),
            dashBoardChartPanelVisible: chartPanel.visible,
            dashBoardChartPanelPanelSize: chartPanel.size,
            dashBoardChartPanelChartPanel: chartPanel,
            dashBoardChartPanelReservedChartPanelNames: chartPanels.map(i => i.reportTitle)
        });
    };

    handleCloseSelectTaskTypeChart = () => {
        this.setState({
            showDashBoardChartPanelSelect: false,
        });
    };

    handleAddNewTaskTypeChartPanel = (taskTypeId: string, chartName) => {
        const state = this.state;
        const taskType = state.taskTypes.find(i => i.id === taskTypeId);
        if (!taskType) return;
        const chart = taskType.charts.find(i => i.name === chartName);
        if (!chart) return;
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const chartPanel = SavedChartPanel.CreateBasicSavedChartPanel("", taskTypeId, `${taskType.code} - ${chart.title}`, chart.name, Base.maxVal(state.dashBoardPanels.map(i => i.position), -1) + 1, {}, ApplicationPermissionType.Task);
        chartPanel.visible = true;
        this.setState({
            showDashBoardChartPanelSelect: false,
            showDashBoardChartPanel: true,
            reportFilterReport: null,
            dashBoardChartPanelFilter: getFilterStateFromTaskGeneralFilter(chartPanel.generalFilter),
            dashBoardChartPanelVisible: chartPanel.visible,
            dashBoardChartPanelPanelSize: chartPanel.size,
            dashBoardChartPanelChartPanel: chartPanel,
            dashBoardChartPanelReservedChartPanelNames: chartPanels.map(i => i.reportTitle)
        });
    };
    //showDashBoardChartPanelSelect
    
    handleChartPanelSaved = (chartPanel: ISavedChartPanel) => {
        const state = this.state;
        if (!chartPanel || !state.dashBoardChartPanelChartPanel) return;
        const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        const saveChartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const oldChartPanel = saveChartPanels.find(i => i.id === state.dashBoardChartPanelChartPanel.id);
        const chartPanels = saveChartPanels.filter(i => i.id !== chartPanel.id && i.id !== state.dashBoardChartPanelChartPanel.id);
        chartPanels.push(chartPanel);
        this.setState({
            showDashBoardChartPanel: false,
            dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
        });
        if (!oldChartPanel) return;
        removeFrontPanelFromState(oldChartPanel.getUniqueId());
    };

    handleChartPanelRemoved = (chartPanelId: string) => {
        if (!chartPanelId) return;
        const state = this.state;
        const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        const saveChartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const oldChartPanel = saveChartPanels.find(i => i.id === chartPanelId);
        const chartPanels = saveChartPanels.filter(i => i.id !== chartPanelId);
        this.setState({
            showDashBoardChartPanel: false,
            dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
        });
        if (!oldChartPanel) return;
        removeFrontPanelFromState(oldChartPanel.getUniqueId());
    };

    // onChartPanelReportFilterDialogOk = async (filterState: ITaskPageFilterState, parameters: ITaskDataRow, selectedChartId: string, panelSize: number, panelVisible: boolean) => {
    //     console.log("onChartPanelReportFilterDialogOk", filterState, parameters, selectedChartId, panelSize, panelVisible);
    //     const state = this.state;
    //     const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
    //     const chartPanels = state.dashBoardPanels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
    //     console.log("pagePanels", pagePanels);
    //     console.log("chartPanels", chartPanels);
    //     const chartPanel = chartPanels.find(i => i.id === state.dashBoardChartPanelChartPanel.id);
    //     console.log("chartPanel", chartPanel);
    //     if (!chartPanel) return;
    //     const chartItem = state.chartItems.find(i => i.reportName === chartPanel.reportId);
    //     if (!chartItem) return;
    //     const newState = {
    //         ...this.state,
    //         selectedUnitIds: filterState.selectedUnitIds,
    //         selectedStateIds: filterState.selectedStateIds,
    //         selectedPriorityIds: filterState.selectedPriorityIds,
    //         selectedTaskTypeIds: filterState.selectedTaskTypeIds,
    //         selectedHandlerUserCodes: filterState.selectedHandlerUserCodes,
    //         selectedPersonInChargeUserCodes: filterState.selectedPersonInChargeUserCodes,
    //         selectedTaskTypeHeaderFields: filterState.selectedTaskTypeHeaderFields,
    //         selectedTaskTypeFields: filterState.selectedTaskTypeFields
    //     };
    //     chartPanel.size = panelSize;
    //     chartPanel.visible = panelVisible;
    //     chartPanel.chartId = selectedChartId;
    //     chartPanel.generalFilter = TaskPageDashboardChart.getGeneralFilterFromState(newState);
    //     chartPanel.reportFilter = SaveReportDialog.getReportFilterFromTaskType(chartItem.taskType, parameters);
    //     this.setState({
    //         showDashBoardChartPanel: false,
    //         dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
    //     });
    //     await taskService.saveTaskChartPanels([chartPanel]);
    // };
    
    handleChartPanelReportFilterDialogCancel = () => {
        this.setState({
            showDashBoardChartPanel: false
        });
    };
    
    static getDefaultSavedReportFilter = (toDoItem: IFrontToDoItem): TDefaultReportFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id.startsWith("ExcelReport_")) {
            const savedReportId = toDoItem.id.replace("ExcelReport_", "");
            return {
                reportId: "",
                savedReportId
            };
        }
        return null;
    };
    
    static getDefaultListFilter = (toDoItem: IFrontToDoItem, userCode: string): TDefaultListFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id === "PersonInChargeTaskCount") {
            return {
                filterId: Translations.Tasks,
                generalFilter: {
                    personInChargeUserCodes: [userCode]
                }
            };
        }
        if (toDoItem.id === "AllTasksCount") {
            return {
                filterId: Translations.Tasks,
            };
        }
        if (toDoItem.id.startsWith("TaskType_")) {
            const taskTypeId = toDoItem.id.replace("TaskType_", "");
            return {
                filterId: Translations.Tasks,
                generalFilter: {
                    taskTypeIds: [taskTypeId]
                }
            };
        }
        return null;
    };
    
    handleToItemClick = (toDoItem: IFrontToDoItem) => {
        const defaultReportFilter = TaskPage.getDefaultSavedReportFilter(toDoItem);
        if (defaultReportFilter) {
            this.handleSetActiveViewType(TaskPageViewType.Reports, defaultReportFilter.reportId, defaultReportFilter.savedReportId, defaultReportFilter.generalFilter, defaultReportFilter.reportFilter);
            return;
        }
        const defaultListFilter = TaskPage.getDefaultListFilter(toDoItem, this.props.appState.state.code);
        this.handleSetActiveViewType(TaskPageViewType.Tasks, defaultListFilter?.filterId, null, defaultListFilter?.generalFilter);
    };
    // #endregion Dashboard

    // #region Transh bin dialog
    handleOpenTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: true
        });
    };
    
    handleCloseTrashBinDialog = () => {
        this.setState({
            showTrashBinDialog: false,
            dataId: this.state.dataId + 1
        });
    };
    // #endregion Transh bin dialog

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.taskPage ? props.taskPage.companies : [];
        const dashboardViewIsActive = state.activeViewTypeId === TaskPageViewType.Dashboard;
        const recordsViewIsActive = state.activeViewTypeId === TaskPageViewType.Tasks;
        const reportsViewIsActive = state.activeViewTypeId === TaskPageViewType.Reports;
        const settingsVisible = state.settingsActions?.length > 0;
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.Tasks}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar justifyContent="space-between">
                        <PageTabs
                            activeTabId={state.activeViewTypeId}
                            tabs={[
                                { id: TaskPageViewType.Dashboard, title: Translations.FrontPage },
                                { id: TaskPageViewType.Tasks, title: Translations.Tasks },
                                { id: TaskPageViewType.Reports, title: Translations.Reports }
                            ]}
                            changeTab={this.handleSetActiveViewType}
                        />
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    {!dashboardViewIsActive &&
                        <PageListAndReportsContainer>
                            {recordsViewIsActive &&
                                <TaskList
                                    filterName={state.activeSavedFilterId
                                        ? state.savedFilters.find(i => i.id === state.activeSavedFilterId)?.title
                                        : state.activeFilterId && state.activeFilterId !== Translations.Tasks
                                            ? state.filters.find(i => i.id === state.activeFilterId)?.title
                                            : null
                                    }
                                    sessionState={sessionState}
                                    dataId={state.dataId.toString(10)}
                                    addRecord={state.listAddRecord}
                                    canCreateTasks={state.canCreateTasks}
                                    listFilterIsSet={state.listFilterIsSet}
                                    units={state.units}
                                    selectedUnitIds={state.selectedUnitIds}
                                    selectedStateIds={state.selectedStateIds}
                                    selectedPriorityIds={state.selectedPriorityIds}
                                    selectedTaskTypeIds={state.selectedTaskTypeIds}
                                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                    selectedPersonInChargeUserCodes={state.selectedPersonInChargeUserCodes}
                                    selectedTaskTypeHeaderFields={state.selectedTaskTypeHeaderFields}
                                    selectedTaskTypeFields={state.selectedTaskTypeFields}
                                    companyId={state.activeCompanyId}
                                    sortColumn={state.sortColumn}
                                    sortOrderIsAsc={state.sortOrderIsAsc}
                                    thrashBin={false}
                                    showDocumentPreview={state.showDocumentPreview}
                                    onOpenFiltersDialog={this.handleShowListFilter}
                                    onSetSortData={this.handleFilterSortData}
                                    onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                                    onOpenTrashBinDialog={this.handleOpenTrashBinDialog}
                                    onChangeShowDocumentPreview={this.handleShowDetailsPanel}
                                    reportTabs={(
                                        <FilterTabs
                                            items={state.savedFilters}
                                            standardFilters={state.filters}
                                            selectedId={this.state.activeFilterId}
                                            selectedSavedId={this.state.activeSavedFilterId}
                                            onSetActiveItem={this.handleChangeActiveSavedFilter}
                                            onSetActiveStandardItem={this.handleChangeActiveFilter}
                                        />
                                    )}
                                />
                            }
                            {reportsViewIsActive &&
                                <PageReportsContainer>
                                    <TaskPageReport
                                        companyId={state.activeCompanyId}
                                        reports={state.activeReportId ? state.reports : state.savedReports}
                                        reportId={state.activeReportId ? state.activeReportId : state.activeSavedReportId}
                                        selectedUnitIds={state.selectedUnitIds}
                                        selectedStateIds={state.selectedStateIds}
                                        selectedPriorityIds={state.selectedPriorityIds}
                                        selectedTaskTypeIds={state.selectedTaskTypeIds}
                                        selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                        selectedPersonInChargeUserCodes={state.selectedPersonInChargeUserCodes}
                                        selectedTaskTypeHeaderFields={state.selectedTaskTypeHeaderFields}
                                        selectedTaskTypeFields={state.selectedTaskTypeFields}
                                        onSetSortData={this.handleFilterSortData}
                                    />
                                    <ReportSettings
                                        filters={
                                            <TaskPageReportFilterPanel
                                                report={state.reportFilterReport}
                                                units={state.units}
                                                states={state.states}
                                                priorities={state.priorities}
                                                taskTypes={state.taskTypesForReportsAndCharts}
                                                handlers={state.handlers}
                                                personsInCharge={state.personsInCharge}
                                                selectedUnitIds={state.selectedUnitIds}
                                                selectedStateIds={state.selectedStateIds}
                                                selectedPriorityIds={state.selectedPriorityIds}
                                                selectedTaskTypeIds={state.selectedTaskTypeIds}
                                                selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                                selectedPersonInChargeUserCodes={state.selectedPersonInChargeUserCodes}
                                                selectedTaskTypeHeaderFields={state.selectedTaskTypeHeaderFields}
                                                selectedTaskTypeFields={state.selectedTaskTypeFields}
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                onSaveReport={this.handleSaveAsReportsModifiedReport}
                                                onRemoveReport={this.handleRemoveSavedReport}
                                                onOk={this.onTaskReportFilterPanelOk}
                                                onCancel={null}
                                            />
                                        }
                                        filtersPadding={"0"}
                                        reports={
                                            <PageNavMenuReportList
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                items={state.savedReports}
                                                standardReports={state.reports}
                                                activeItemId={state.activeSavedReportId}
                                                activeStandardItemId={state.activeReportId}
                                                showingSavedReports={true}
                                                title={Translations.Report}
                                                onSetActiveItem={this.handleChangeActiveSavedReport}
                                                onSetActiveStandardItem={this.handleChangeActiveReport}
                                            />
                                        }
                                    />
                                </PageReportsContainer>
                            }
                        </PageListAndReportsContainer>
                    }
                    {dashboardViewIsActive &&
                        <DashboardPanelList
                            companyId={state.activeCompanyId}
                            applicationPermissionType={ApplicationPermissionType.Task}
                            canSharePanels={sessionState.isCompanyAdmin}
                            hidden={!state.showDashBoardNavPanel}
                            panels={state.dashBoardPanels}
                            enableShowInFrontPage={true}
                            onUpdatePanels={this.handleUpdateDashBoardPanels}
                            onSavePanels={this.handleSaveDashBoardPanels}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onShowChartPanelProperties={this.handleShowChartPanelProperties}
                            onAddChart={this.handleAddChartPanel}
                            onGetSharedPanels={taskService.getSharedPanels}
                            onSaveSharedPanel={taskService.saveSharedPanel}
                            onGetUserGroupSelectListItems={taskService.getSharePanelUserGroupListItems}
                        />
                    }
                    {dashboardViewIsActive &&
                        <PageDashboard
                            title={Translations.TaskDashboard}
                            settingsVisible={settingsVisible}
                            panels={state.dashBoardPanels}
                            companyId={state.activeCompanyId}
                            filters={state.filters}
                            savedFilters={state.savedFilters}
                            loadingReports={state.loadingReports}
                            reports={state.reports}
                            savedReports={state.savedReports}
                            chartItems={state.reportChartItems} //Not in use
                            taskTypes={state.taskTypes}
                            dashboardChart={TaskPageDashboardChart}
                            addButton={state.canCreateTasks
                                ? <AddButton variant="contained" onClick={this.handleAddTask} sx={{ marginRight: "24px" }}>{Translations.AddTask}</AddButton>
                                : undefined}
                            onSavedFilterClick={this.handleDashboardSavedFilterClick}
                            onFilterClick={this.handleDashboardFilterClick}
                            onSavedReportClick={this.handleDashboardSavedReportClick}
                            onReportClick={this.handleDashboardReportClick}
                            onShowChartPanelPropertiesDialog={this.handleShowChartPanelProperties}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onToggleSettingsDialog={this.handleOpenSettingsDialog}
                            onGetToDoItems={taskService.getTaskToDoItems}
                            onStatisticsClick={this.handleToItemClick}
                        />
                    }
                </PageContent>
                <TaskPageFilterDrawer
                    open={state.showListFilter}
                    filter={state.listFilterFilter}
                    units={state.units}
                    states={state.states}
                    priorities={state.priorities}
                    taskTypes={state.taskTypes}
                    handlers={state.handlers}
                    personsInCharge={state.personsInCharge}
                    selectedUnitIds={state.selectedUnitIds}
                    selectedStateIds={state.selectedStateIds}
                    selectedPriorityIds={state.selectedPriorityIds}
                    selectedTaskTypeIds={state.selectedTaskTypeIds}
                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                    selectedPersonInChargeUserCodes={state.selectedPersonInChargeUserCodes}
                    selectedTaskTypeHeaderFields={state.selectedTaskTypeHeaderFields}
                    selectedTaskTypeFields={state.selectedTaskTypeFields}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.handleListFilterPanelOk}
                    onCancel={this.handleFilterPanelCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Task}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showDashBoardChartPanelSelect &&
                    <TaskPageSelectChartDrawer
                        taskTypes={state.taskTypes}
                        onCancel={this.handleCloseSelectTaskTypeChart}
                        onSelect={this.handleAddNewTaskTypeChartPanel}
                    />
                }
                {state.showDashBoardChartPanel &&
                    <TaskPageReportFilterPanel
                        chartPanelDrawerMode={true}
                        report={state.reportFilterReport}
                        chartPanel={state.dashBoardChartPanelChartPanel}
                        reservedChartPanelNames={state.dashBoardChartPanelReservedChartPanelNames}
                        panelSize={state.dashBoardChartPanelPanelSize}
                        panelVisible={state.dashBoardChartPanelVisible}
                        units={state.units}
                        states={state.states}
                        priorities={state.priorities}
                        taskTypes={state.taskTypesForReportsAndCharts}
                        handlers={state.handlers}
                        personsInCharge={state.personsInCharge}
                        selectedUnitIds={state.dashBoardChartPanelFilter.selectedUnitIds}
                        selectedStateIds={state.dashBoardChartPanelFilter.selectedStateIds}
                        selectedPriorityIds={state.dashBoardChartPanelFilter.selectedPriorityIds}
                        selectedTaskTypeIds={state.dashBoardChartPanelFilter.selectedTaskTypeIds}
                        selectedHandlerUserCodes={state.dashBoardChartPanelFilter.selectedHandlerUserCodes}
                        selectedPersonInChargeUserCodes={state.dashBoardChartPanelFilter.selectedPersonInChargeUserCodes}
                        selectedTaskTypeHeaderFields={state.dashBoardChartPanelFilter.selectedTaskTypeHeaderFields}
                        selectedTaskTypeFields={state.dashBoardChartPanelFilter.selectedTaskTypeFields}
                        canRemoveSharedReports={false}
                        onSaveReport={null}
                        onRemoveReport={null}
                        onOk={null}
                        onChartPanelSaved={this.handleChartPanelSaved}
                        onChartPanelRemoved={this.handleChartPanelRemoved}
                        onCancel={this.handleChartPanelReportFilterDialogCancel}
                    />
                }
                {state.showReportSaveDialog &&
                    <SaveReportDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Task}
                        report={state.reportSaveDialogReport}
                        generalFilter={state.reportSaveDialogGeneralFilter}
                        reservedNames={state.reportSaveDialogReservedNames}
                        onGetReportSaveFilters={state.reportSaveDialogOnGetReportSaveFilters}
                        onOk={this.handleReportSaveDialogOk}
                        onCancel={this.handleReportSaveDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <TaskSettingsDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        settingsActions={state.settingsActions}
                        onClose={this.handleSettingsDialogOk}
                    />
                }
                {state.showTrashBinDialog &&
                    <TaskTrashBinDialog
                        sessionState={props.appState.state}
                        companyId={state.activeCompanyId}
                        units={state.units}
                        onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                        onClose={this.handleCloseTrashBinDialog}
                    />
                }
            </PageContainer>
        );
    }
}